import React, { useEffect, useState } from 'react';
import axios from '../api/axios';
import Sidebar from '../components/Sidebar';
import { toast } from 'react-toastify';

function BankTransactions() {
  const [transactions, setTransactions] = useState([]);
  const [form, setForm] = useState({ bank_id: '', type: 'deposit', amount: '', description: '' });

  const fetchTransactions = () => {
    if (form.bank_id) {
      axios.get(`/bank-transactions/${form.bank_id}`).then(res => setTransactions(res.data));
    }
  };

  useEffect(() => {
    fetchTransactions();
  }, [form.bank_id]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await axios.post('/bank-transactions', form);
      toast.success("Transaction recorded!");
      setForm({ ...form, amount: '', description: '' });
      fetchTransactions();
    } catch {
      toast.error("Error saving transaction.");
    }
  };

  return (
    <div className="flex">
      
      <div className="p-6 w-full">
        <h2 className="text-2xl font-bold mb-4">Bank Transactions</h2>
        <form onSubmit={handleSubmit} className="space-y-2 mb-6">
          <input className="border w-full p-2" placeholder="Bank ID" value={form.bank_id} onChange={e => setForm({ ...form, bank_id: e.target.value })} />
          <select className="border w-full p-2" value={form.type} onChange={e => setForm({ ...form, type: e.target.value })}>
            <option value="deposit">Deposit</option>
            <option value="withdraw">Withdraw</option>
          </select>
          <input className="border w-full p-2" placeholder="Amount" type="number" value={form.amount} onChange={e => setForm({ ...form, amount: e.target.value })} />
          <input className="border w-full p-2" placeholder="Description" value={form.description} onChange={e => setForm({ ...form, description: e.target.value })} />
          <button type="submit" className="bg-blue-600 text-white px-4 py-2">Add Transaction</button>
        </form>

        <table className="table-auto w-full text-left border border-gray-300">
          <thead>
            <tr><th>Type</th><th>Amount</th><th>Description</th><th>Date</th></tr>
          </thead>
          <tbody>
            {transactions.map(t => (
              <tr key={t.id}>
                <td>{t.type}</td>
                <td>${t.amount}</td>
                <td>{t.description}</td>
                <td>{new Date(t.transaction_date).toLocaleString()}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}

export default BankTransactions;